/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Output_Filename_LabelInputs */

const en_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output filename`)
};

const fr_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nom du fichier de sortie`)
};

const de_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabedateiname`)
};

const it_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del file di output`)
};

const ru_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Имя выходного файла`)
};

const es_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nombre del archivo de salida`)
};

const zh_cn2_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出文件名`)
};

const ja_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力ファイル名`)
};

const hi_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट फ़ाइल नाम`)
};

const pt_pt2_audio_embed_export_output_filename_label = /** @type {(inputs: Audio_Embed_Export_Output_Filename_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do arquivo de saída`)
};

/**
* | output |
* | --- |
* | "Output filename" |
*
* @param {Audio_Embed_Export_Output_Filename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_output_filename_label = /** @type {((inputs?: Audio_Embed_Export_Output_Filename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Output_Filename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_output_filename_label(inputs)
	if (locale === "de") return de_audio_embed_export_output_filename_label(inputs)
	if (locale === "it") return it_audio_embed_export_output_filename_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_output_filename_label(inputs)
	if (locale === "es") return es_audio_embed_export_output_filename_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_output_filename_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_output_filename_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_output_filename_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_output_filename_label(inputs)
	return en_audio_embed_export_output_filename_label(inputs)
});